import {
  Button,
  Container,
  Checkbox,
  GridList,
  GridListItem,
} from '@plone/components';
import '@plone/components/dist/basic.css';
import 'animate.css';
import { useState } from 'react';

function View(props) {
  const [press, setPress] = useState('false');

  return (
    <Container>
      <Button
        className={press ? 'animate__bounceIn' : 'animate__bounceIn'}
        onBlur={() => {}}
        onFocus={() => {}}
        onFocusChange={() => {}}
        onHoverChange={() => {}}
        onHoverEnd={() => {}}
        onHoverStart={() => {}}
        onKeyDown={() => {}}
        onKeyUp={() => {}}
        onPress={() => {
          setPress(!press);
        }}
        onPressChange={() => {}}
        onPressEnd={() => {}}
        onPressStart={() => {}}
        onPressUp={() => {}}
      >
        Press me
      </Button>

      <Checkbox
        onBlur={() => {}}
        onChange={() => {}}
        onFocus={() => {}}
        onFocusChange={() => {}}
        onHoverChange={() => {}}
        onHoverEnd={() => {}}
        onHoverStart={() => {}}
        onKeyDown={() => {}}
        onKeyUp={() => {}}
      >
        Unsubscribe
      </Checkbox>

      <GridList
        aria-label="Ice cream flavors"
        onAction={null}
        onScroll={() => {}}
        onSelectionChange={() => {}}
        selectionMode="multiple"
      >
        <GridListItem>Chocolate</GridListItem>
        <GridListItem>Mint</GridListItem>
        <GridListItem>Strawberry</GridListItem>
        <GridListItem>Vanilla</GridListItem>
      </GridList>
    </Container>
  );
}

export default View;
